import { showExcept, showIfPresent, hideAll } from "../element-utils";

const uiActionElementIndex = {
  content: 0,
  call: 1,
  email: 2,
  browser: 3,
  rsvp: 4,
  referral: 5,
};

class InputFieldsGroup {
  constructor(
    uiActionInputFieldsContainerSelector,
    uiActionMainContainerSelector,
    options = {
      hasSubpPage: false,
      hasCallToAction: true,
    }
  ) {
    this.uiActionMainContainerSelector = $(uiActionMainContainerSelector);
    this.uiActionInputFieldsContainerSelector =
      this.uiActionMainContainerSelector.find(
        uiActionInputFieldsContainerSelector
      );
    this.options = options;
  }

  getCallField = () => {
    if (!this.callField) {
      this.callField = this.uiActionInputFieldsContainerSelector
        .find(".ui_action_payload_phone_no_field")
        .first();
    }

    return this.callField;
  };

  getBrowserField = () => {
    if (!this.browserField) {
      this.browserField = this.uiActionInputFieldsContainerSelector
        .find(".ui_action_payload_url_field")
        .first();
    }

    return this.browserField;
  };

  getEmailField = () => {
    if (!this.emailField) {
      this.emailField = this.uiActionInputFieldsContainerSelector
        .find(".ui_action_payload_email_address_field")
        .first();
    }

    return this.emailField;
  };

  getReferralField = () => {
    if (!this.referralField) {
      this.referralField = this.uiActionInputFieldsContainerSelector
        .find(".ui_action_payload_referral_program_field")
        .first();
    }

    return this.referralField;
  };

  getRsvpField = () => {
    if (!this.rsvpField) {
      this.rsvpField = this.uiActionInputFieldsContainerSelector
        .find(".ui_action_payload_campaign_field")
        .first();
    }

    return this.rsvpField;
  };

  getCallToActionField = () => {
    if (!this.callToActionField) {
      this.callToActionField = this.options.hasCallToAction
        ? this.uiActionInputFieldsContainerSelector
            .find(".ui_action_call_to_action_field")
            .first()
        : null;
    }

    return this.callToActionField;
  };

  getSubPageContentFields = () => {
    if (!this.subPageContentFields) {
      this.subPageContentFields = this.options.hasSubPage
        ? this.uiActionMainContainerSelector.find("#sub_page_contents").first()
        : $();
    }
    return this.subPageContentFields;
  };

  getSubPageTitleField = () => {
    if (!this.subPageTitleField) {
      this.subPageTitleField = this.getSubPageContentFields()
        .find("#sub_page_title")
        .first()
        .find("input");
    }
    return this.subPageTitleField;
  };

  getAllInputFields = () => {
    if (!this.fields) {
      this.fields = [
        this.getSubPageContentFields(),
        this.getCallField(),
        this.getEmailField(),
        this.getBrowserField(),
        this.getRsvpField(),
        this.getReferralField(),
      ];
    }

    return this.fields;
  };

  toggleRelevantUiActionFields = (value) => {
    switch (value) {
      case "content":
      case "call":
      case "email":
      case "browser":
      case "referral":
      case "rsvp":
        showExcept(uiActionElementIndex[value], this.getAllInputFields());
        showIfPresent(this.getCallToActionField());
        break;
      default:
        const callToActionField = this.getCallToActionField();
        if (callToActionField) {
          callToActionField.hide();
        }
        hideAll(this.getAllInputFields());
    }
  };

  hideAllFields = () => {
    hideAll(this.getAllInputFields());
    const callToActionField = this.getCallToActionField();
    if (callToActionField) {
      callToActionField.hide();
    }
  };

  toggleSubPageRequiredField = (show) => {
    if (show) {
      this.getSubPageTitleField().attr("required", true);
    } else {
      this.getSubPageTitleField().attr("required", false);
    }
  };
}

export default InputFieldsGroup;
